import React from "react";
import { Modal, CloseButton } from "react-bootstrap";

import { useSelector, useDispatch } from "react-redux";
import { onHideExtensionModal } from "../../store/slices/preferenceSlice";

const CheckExtensionModal = () => {
  const dispatch = useDispatch();
  const { showExtensionModal } = useSelector((state) => state.preference);

  return (
    <Modal
      centered
      aria-labelledby="contained-modal-title-vcenter"
      show={showExtensionModal}
    >
      <Modal.Body>
        <div className="d-flex flex-row justify-content-end mb-2">
          <CloseButton onClick={() => dispatch(onHideExtensionModal())} />
        </div>
        <p style={{ fontSize: "16px" }}>
          Your extension is not installed please install the extension to
          proceed further.
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default CheckExtensionModal;
